var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f34f449ee16d653579455616f00f1bfa5531d0a0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["customer-frontend@linkgraph"]={id:"f34f449ee16d653579455616f00f1bfa5531d0a0"};
      